import React from "react";

export const IsLockedContext = React.createContext<boolean>(false);
